/// <amd-module name="Wit/MarkdownEditorReduxAdapter/Redux/MarkdownEditorReducer" />
import produce from "immer";
import { ICreateAttachmentSucceededParams, MarkdownActions, MarkdownActionTypes } from "Wit/MarkdownEditorReduxAdapter/Redux/MarkdownEditorActions";
import { IMarkdownStateMap, MarkdownPreviewState } from "Wit/MarkdownEditorReduxAdapter/Redux/MarkdownEditorContracts";

export const defaultMarkdownState = {};

export function markdownReducer(state: IMarkdownStateMap, action: MarkdownActions): IMarkdownStateMap {
    // tslint:disable-next-line:cyclomatic-complexity
    return produce(state || defaultMarkdownState, draft => {
        switch (action.type) {
            case MarkdownActionTypes.InitializeMarkdown: {
                const { key, initialValue = "" } = action.payload;
                if (!draft[key.workItemId]) {
                    draft[key.workItemId] = {};
                }
                draft[key.workItemId][key.fieldRefName] = { editorValue: initialValue, previewState: MarkdownPreviewState.NotAvailable };
                break;
            }
            case MarkdownActionTypes.TextChanged: {
                const { key, newText } = action.payload;
                if (draft[key.workItemId] && draft[key.workItemId][key.fieldRefName]) {
                    draft[key.workItemId][key.fieldRefName].editorValue = newText;
                }
                break;
            }
            case MarkdownActionTypes.CreateAttachmentSucceeded: {
                const { key, paramsList, selectionStart, selectionEnd } = action.payload;
                if (draft[key.workItemId] && draft[key.workItemId][key.fieldRefName]) {
                    draft[key.workItemId][key.fieldRefName].editorValue = insertAttachmentText(
                        draft[key.workItemId][key.fieldRefName].editorValue,
                        selectionStart,
                        selectionEnd,
                        paramsList
                    );
                }
                break;
            }
            case MarkdownActionTypes.DisposeMarkdown: {
                const key = action.payload;
                if (draft[key.workItemId] && draft[key.workItemId][key.fieldRefName]) {
                    delete draft[key.workItemId][key.fieldRefName];
                }
                break;
            }
            case MarkdownActionTypes.SetPreview: {
                const { key, previewHTML } = action.payload;
                if (draft[key.workItemId] && draft[key.workItemId][key.fieldRefName]) {
                    draft[key.workItemId][key.fieldRefName].previewValue = previewHTML;
                    draft[key.workItemId][key.fieldRefName].previewState = MarkdownPreviewState.Available;
                }
                break;
            }
            case MarkdownActionTypes.ResetPreviewState: {
                const key = action.payload;
                if (draft[key.workItemId] && draft[key.workItemId][key.fieldRefName]) {
                    draft[key.workItemId][key.fieldRefName].previewState = MarkdownPreviewState.NotAvailable;
                    draft[key.workItemId][key.fieldRefName].previewValue = undefined;
                }
                break;
            }
            case MarkdownActionTypes.PreviewLoadError: {
                const key = action.payload;
                if (draft[key.workItemId] && draft[key.workItemId][key.fieldRefName]) {
                    draft[key.workItemId][key.fieldRefName].previewState = MarkdownPreviewState.Error;
                    draft[key.workItemId][key.fieldRefName].previewValue = undefined;
                }
                break;
            }
        }
    });
}

export const insertAttachmentText = (prevText: string, selectionStart: number, selectionEnd: number, paramsList: ICreateAttachmentSucceededParams[]): string => {
    // if selectionStart and selectionEnd are invalid, make them 0.
    let start = selectionStart;
    let end = selectionEnd;
    if (start > end || start < 0 || end < 0 || start > prevText.length || end > prevText.length) {
        start = 0;
        end = 0;
    }
    const firstPart = prevText.substring(0, start);
    const endPart = prevText.substring(end);
    let markdownText = "";
    for (const params of paramsList) {
        markdownText += `${params.isImage ? "![" : "["}${params.fileName}](${params.url})`;
    }
    return firstPart + markdownText + endPart;
};
